export default __webpack_public_path__ + "static/banner-what-to-do-when-you-have-car-accident-6469d436b042f7b68956dfa5faa1f6eb.jpg";